<template>
  <button
    class="page-menu-main-button flex flex-col items-center justify-center whitespace-nowrap text-primary"
    :class="{
      '!text-muted': isMuted,
      'active-link-popover': isOpen && id !== 'menu',
    }"
    :data-testid="`nav-link-${id}`"
    @click.prevent="onClick"
  >
    <div class="relative size-[1em] text-[24px]">
      <SpriteSymbol
        :name="icon"
        class="absolute top-0 left-0 size-full transition duration-300 ease-bounce"
        :class="{
          'scale-[0.3] opacity-0': isOpen,
        }"
      />
      <SpriteSymbol
        name="menu-close"
        class="absolute top-0 left-0 size-full transition duration-300 ease-swing"
        :class="{
          'scale-0 rotate-12 opacity-0': !isOpen,
        }"
      />
    </div>
    <span
      class="mt-2 text-size-7 leading-none font-bold transition duration-300"
      >{{ title }}</span
    >
  </button>
</template>

<script setup lang="ts">
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-icon-sprite/runtime'

const props = defineProps<{
  id: string
  title: string
  icon: NuxtSvgSpriteSymbol
}>()

const { trackEvent } = useAnalytics()

const active = defineModel<string>()

const isOpen = computed(() => active.value === props.id)
const isMuted = computed(() => active.value && !isOpen.value)

function onClick() {
  if (isOpen.value) {
    active.value = ''
  } else {
    active.value = props.id
  }

  trackEvent({
    event: 'click_navbar_element',
    element_name: props.title,
    element_id: `navbar-link-${props.id}`,
    element_url: '',
  })
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.page-menu-main-button {
  @apply relative;
  height: var(--page-menu-bottom);
  width: auto;
  padding-inline: 0.35rem;

  &:last-child {
    /* Align the menu icon with the container edge, matching the logo inset. */
    padding-right: 0;
  }

  @variant tablet {
    width: var(--page-menu-bottom);
    padding-inline: 0;

    &:last-child {
      /* Visually align the last button in the menu with the container. */
      margin-right: -0.8em;
    }

    &.active-link-popover:after {
      @apply absolute bg-background;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      content: '';
      height: 2rem;
      right: 0;
      top: 4.5rem;
      transform: translateX(-50%) rotate(45deg);
      width: 2rem;
      opacity: 0;
      animation: fadeIn 0.1s ease-in-out 0.1s forwards;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
